import { render, staticRenderFns } from "./ErrorScreen.vue?vue&type=template&id=552d6fa3&scoped=true&"
import script from "./ErrorScreen.vue?vue&type=script&lang=ts&"
export * from "./ErrorScreen.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorScreen.vue?vue&type=style&index=0&id=552d6fa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552d6fa3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
